import { render } from "./PeopleAccountsList.vue?vue&type=template&id=60bb7fa8"
import script from "./PeopleAccountsList.vue?vue&type=script&lang=js"
export * from "./PeopleAccountsList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__